<template>
    <div class="sc-form-row">
        <div class="form-label-row">
            <div class="sc-field-label">
                <span>{{ cleanLabel }}</span>
            </div>
            <div class="sc-field-error" v-if="errors">
                <div v-for="error in errors">
                    <template v-if="Array.isArray(error)">
                        <div v-for="e in error">{{ e }}</div>
                    </template>
                    <template v-else>{{ error }}</template>
                </div>
            </div>
            <div class="sc-field-description" v-if="description">
                <span>{{ description }}</span>
            </div>
        </div>
        <div class="input">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
  name: "sc-form-field",
  props: {
    form: Object,
    field: {
      type: String,
      default: 'field'
    },
    description: {
      type: String
    },
    name: {
      type: String
    }
  },

  computed: {
    errors() {
      if (this.form && this.form.errors.errors) {
        if (this.form.errors.errors.hasOwnProperty(this.field)) {
          return this.form.errors.errors[this.field];
        }
      }
    },
    cleanLabel() {
      let value = (this.name) ? this.name : this.field;
      if (!value) return '';
      value = value.toString();
      value = value.charAt(0).toUpperCase() + value.slice(1);
      value = value.split('_').join(' ');
      return value;
    }
  }
}
</script>

<style scoped>
.sc-form-row {
    margin-bottom: 28px;
}

.sc-field-label {
    font-weight: 700;
    /*text-transform: uppercase;*/
    /*font-size: 0.8em;*/
    margin-bottom: 0.5em;
}

.sc-field-error {
    color: red;
    font-weight: 700;
    font-size: 0.8em;
    margin: 0.5em 0;
}

.sc-field-description {
    margin: 0 0 0.5em;
    font-size: 0.9em;
}


</style>